package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ParcoursStepQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    skill_id: String,
    code: String,
    kind: String,
    position: Long,
    title: String,
    summary: String?,
    planned_min: Long,
    level_name: String?,
    level_desc: String?,
    project_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-2_141_481_194, arrayOf("parcours_step"), driver, "ParcoursStep.sq",
      "selectAll",
      "SELECT parcours_step.id, parcours_step.skill_id, parcours_step.code, parcours_step.kind, parcours_step.position, parcours_step.title, parcours_step.summary, parcours_step.planned_min, parcours_step.level_name, parcours_step.level_desc, parcours_step.project_id, parcours_step.created_at, parcours_step.updated_at, parcours_step.is_deleted, parcours_step.deleted_at, parcours_step.synced_at FROM parcours_step WHERE is_deleted = 0 ORDER BY skill_id, position") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectAll(): Query<Parcours_step> = selectAll { id, skill_id, code, kind, position,
      title, summary, planned_min, level_name, level_desc, project_id, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Parcours_step(
      id,
      skill_id,
      code,
      kind,
      position,
      title,
      summary,
      planned_min,
      level_name,
      level_desc,
      project_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectBySkill(skill_id: String, mapper: (
    id: String,
    skill_id: String,
    code: String,
    kind: String,
    position: Long,
    title: String,
    summary: String?,
    planned_min: Long,
    level_name: String?,
    level_desc: String?,
    project_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectBySkillQuery(skill_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectBySkill(skill_id: String): Query<Parcours_step> = selectBySkill(skill_id) { id,
      skill_id_, code, kind, position, title, summary, planned_min, level_name, level_desc,
      project_id, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Parcours_step(
      id,
      skill_id_,
      code,
      kind,
      position,
      title,
      summary,
      planned_min,
      level_name,
      level_desc,
      project_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    skill_id: String,
    code: String,
    kind: String,
    position: Long,
    title: String,
    summary: String?,
    planned_min: Long,
    level_name: String?,
    level_desc: String?,
    project_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectById(id: String): Query<Parcours_step> = selectById(id) { id_, skill_id, code,
      kind, position, title, summary, planned_min, level_name, level_desc, project_id, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Parcours_step(
      id_,
      skill_id,
      code,
      kind,
      position,
      title,
      summary,
      planned_min,
      level_name,
      level_desc,
      project_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByProject(project_id: String?, mapper: (
    id: String,
    skill_id: String,
    code: String,
    kind: String,
    position: Long,
    title: String,
    summary: String?,
    planned_min: Long,
    level_name: String?,
    level_desc: String?,
    project_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByProjectQuery(project_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByProject(project_id: String?): Query<Parcours_step> =
      selectByProject(project_id) { id, skill_id, code, kind, position, title, summary, planned_min,
      level_name, level_desc, project_id_, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Parcours_step(
      id,
      skill_id,
      code,
      kind,
      position,
      title,
      summary,
      planned_min,
      level_name,
      level_desc,
      project_id_,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    skill_id: String,
    code: String,
    kind: String,
    position: Long,
    title: String,
    summary: String?,
    planned_min: Long,
    level_name: String?,
    level_desc: String?,
    project_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-671_401_977, arrayOf("parcours_step"), driver, "ParcoursStep.sq",
      "selectDirty",
      "SELECT parcours_step.id, parcours_step.skill_id, parcours_step.code, parcours_step.kind, parcours_step.position, parcours_step.title, parcours_step.summary, parcours_step.planned_min, parcours_step.level_name, parcours_step.level_desc, parcours_step.project_id, parcours_step.created_at, parcours_step.updated_at, parcours_step.is_deleted, parcours_step.deleted_at, parcours_step.synced_at FROM parcours_step WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectDirty(): Query<Parcours_step> = selectDirty { id, skill_id, code, kind, position,
      title, summary, planned_min, level_name, level_desc, project_id, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Parcours_step(
      id,
      skill_id,
      code,
      kind,
      position,
      title,
      summary,
      planned_min,
      level_name,
      level_desc,
      project_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    skill_id: String,
    code: String,
    kind: String,
    position: Long,
    title: String,
    summary: String?,
    planned_min: Long,
    level_name: String?,
    level_desc: String?,
    project_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Parcours_step> = selectByIdAnyState(id) { id_,
      skill_id, code, kind, position, title, summary, planned_min, level_name, level_desc,
      project_id, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Parcours_step(
      id_,
      skill_id,
      code,
      kind,
      position,
      title,
      summary,
      planned_min,
      level_name,
      level_desc,
      project_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    skill_id: String,
    code: String,
    kind: String,
    position: Long,
    title: String,
    summary: String?,
    planned_min: Long,
    level_name: String?,
    level_desc: String?,
    project_id: String?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(897_574_984, """
        |INSERT INTO parcours_step(id, skill_id, code, kind, position, title, summary, planned_min, level_name, level_desc, project_id, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 13) {
          bindString(0, id)
          bindString(1, skill_id)
          bindString(2, code)
          bindString(3, kind)
          bindLong(4, position)
          bindString(5, title)
          bindString(6, summary)
          bindLong(7, planned_min)
          bindString(8, level_name)
          bindString(9, level_desc)
          bindString(10, project_id)
          bindLong(11, created_at)
          bindLong(12, updated_at)
        }
    notifyQueries(897_574_984) { emit ->
      emit("parcours_step")
    }
  }

  public fun update(
    skill_id: String,
    code: String,
    kind: String,
    position: Long,
    title: String,
    summary: String?,
    planned_min: Long,
    level_name: String?,
    level_desc: String?,
    project_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_242_521_176, """
        |UPDATE parcours_step
        |SET skill_id = ?, code = ?, kind = ?, position = ?, title = ?, summary = ?, planned_min = ?, level_name = ?, level_desc = ?, project_id = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 12) {
          bindString(0, skill_id)
          bindString(1, code)
          bindString(2, kind)
          bindLong(3, position)
          bindString(4, title)
          bindString(5, summary)
          bindLong(6, planned_min)
          bindString(7, level_name)
          bindString(8, level_desc)
          bindString(9, project_id)
          bindLong(10, updated_at)
          bindString(11, id)
        }
    notifyQueries(1_242_521_176) { emit ->
      emit("parcours_step")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-900_471_676,
        """UPDATE parcours_step SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-900_471_676) { emit ->
      emit("parcours_step")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_195_400_927,
        """UPDATE parcours_step SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_195_400_927) { emit ->
      emit("parcours_step")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(302_421_942,
        """UPDATE parcours_step SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(302_421_942) { emit ->
      emit("parcours_step")
    }
  }

  private inner class SelectBySkillQuery<out T : Any>(
    public val skill_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("parcours_step", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("parcours_step", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_976_911_663,
        """SELECT parcours_step.id, parcours_step.skill_id, parcours_step.code, parcours_step.kind, parcours_step.position, parcours_step.title, parcours_step.summary, parcours_step.planned_min, parcours_step.level_name, parcours_step.level_desc, parcours_step.project_id, parcours_step.created_at, parcours_step.updated_at, parcours_step.is_deleted, parcours_step.deleted_at, parcours_step.synced_at FROM parcours_step WHERE skill_id = ? AND is_deleted = 0 ORDER BY position""",
        mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "ParcoursStep.sq:selectBySkill"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("parcours_step", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("parcours_step", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_961_366_275,
        """SELECT parcours_step.id, parcours_step.skill_id, parcours_step.code, parcours_step.kind, parcours_step.position, parcours_step.title, parcours_step.summary, parcours_step.planned_min, parcours_step.level_name, parcours_step.level_desc, parcours_step.project_id, parcours_step.created_at, parcours_step.updated_at, parcours_step.is_deleted, parcours_step.deleted_at, parcours_step.synced_at FROM parcours_step WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "ParcoursStep.sq:selectById"
  }

  private inner class SelectByProjectQuery<out T : Any>(
    public val project_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("parcours_step", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("parcours_step", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT parcours_step.id, parcours_step.skill_id, parcours_step.code, parcours_step.kind, parcours_step.position, parcours_step.title, parcours_step.summary, parcours_step.planned_min, parcours_step.level_name, parcours_step.level_desc, parcours_step.project_id, parcours_step.created_at, parcours_step.updated_at, parcours_step.is_deleted, parcours_step.deleted_at, parcours_step.synced_at FROM parcours_step WHERE project_id ${ if (project_id == null) "IS" else "=" } ? AND is_deleted = 0 LIMIT 1""",
        mapper, 1) {
      bindString(0, project_id)
    }

    override fun toString(): String = "ParcoursStep.sq:selectByProject"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("parcours_step", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("parcours_step", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(275_362_338,
        """SELECT parcours_step.id, parcours_step.skill_id, parcours_step.code, parcours_step.kind, parcours_step.position, parcours_step.title, parcours_step.summary, parcours_step.planned_min, parcours_step.level_name, parcours_step.level_desc, parcours_step.project_id, parcours_step.created_at, parcours_step.updated_at, parcours_step.is_deleted, parcours_step.deleted_at, parcours_step.synced_at FROM parcours_step WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "ParcoursStep.sq:selectByIdAnyState"
  }
}
